// extracted by mini-css-extract-plugin
export default {"globalLoader":"GlobalLoader_globalLoader__JueP7","spin":"GlobalLoader_spin__tOIYi"};